import React from 'react';
// components
import FieldError from '../../../components/Form/FieldError';
import Input from '../../../components/Input/Input';
import Icon from '../../../components/Icon/Icon';
// styles
import styles from './DynamicInputList.mod.css';
import classnames from 'classnames/bind';

const cn = classnames.bind(styles);

const DynamicInputList = ({
  data: {
    content: { id, placeholder },
  },
  errors,
  values,
  setFieldValue,
}) => {
  const inputValues = values[id] && values[id].length ? values[id] : [''];

  const handleChange = (index, event) => {
    const value = event.target.value;
    inputValues[index] = value;
    if (!value) {
      const newArray = inputValues.filter((val, inx) => inx === index || !!val);
      return setFieldValue(id, newArray.length ? newArray : inputValues);
    }
    setFieldValue(id, inputValues);
  };

  const deleteValue = index => {
    inputValues.splice(index, 1);
    setFieldValue(id, inputValues);
  };

  const addInput = () => {
    inputValues[inputValues.length] = '';
    setFieldValue(id, inputValues);
  };

  const canAdd = inputValues.every(value => !!value);
  const idDeletable = inputValues.length > 1;

  return (
    <div className={cn('container')}>
      {inputValues.map((value, index) => (
        <div key={index} className={cn('field-wrapper')}>
          <Input
            wrapperClassName={cn('input-wrapper')}
            value={value}
            autoComplete="none"
            placeholder={placeholder || 'e.g. Something'}
            onChange={e => handleChange(index, e)}
          />
          {idDeletable && (
            <button
              type="button"
              className={cn('button')}
              onClick={() => deleteValue(index)}
            >
              <Icon className={cn('remove-item-icon')} type="delete" />
            </button>
          )}
        </div>
      ))}
      <FieldError error={errors[id]} touched={true} />
      {canAdd && (
        <button type="button" className={cn('button')} onClick={addInput}>
          <Icon className={cn('add-item-icon')} type="add" />
          Add more
        </button>
      )}
    </div>
  );
};

export default DynamicInputList;



// WEBPACK FOOTER //
// ./src/containers/Module/components/DynamicInputList.jsx